import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import './About.css';

function About() {
  usePageMeta({
    title: 'About Us — Founded by Susan Subirias in San Antonio',
    description: "Heaven Sent has been crafting custom apparel and promotional products in San Antonio since 2007. Founded by Susan Subirias and run alongside her daughter Sarita today. Woman & minority-owned, HUB / MBE / WBE / SBE certified.",
    path: '/about',
  });
  return (
    <main className="about-page">
      {/* Hero */}
      <section className="page-hero">
        <h1 className="script-font">About Us</h1>
        <p>Learn more about the heart behind Heaven Sent Promotions</p>
      </section>

      {/* Story */}
      <section className="about-story">
        <div className="about-story-content">
          <div className="about-text">
            <p className="section-label">Our Story</p>
            <h2 className="section-title">Founded on a Heavenly Suggestion</h2>
            <p>In late 2006, Susan Subirias was working as an outside sales rep for a promotional t-shirt company when one of her customers stopped her and asked the question that changed everything: "Why aren't you working for yourself? You're doing it all already."</p>
            <p>A few months later, with a $4,500 tax refund and a name inspired by how fortunate the timing felt, Susan launched Heaven Sent Promotions & Apparel in January 2007. One of the first things she did was get certified as a Historically Underutilized Business (HUB), a Minority Business Enterprise (MBE), a Women's Business Enterprise (WBE), and a Small Business Enterprise (SBE). These credentials have since opened doors with major institutional clients including UTSA, Texas A&M San Antonio, Toyota, and Dr Pepper/Snapple.</p>
            <p>Heaven Sent has always been a family effort. Susan's late mother, Rita Marquez Batson, was the driving force behind the business in its earliest days. Today, Susan's daughter Sarita runs the company alongside her, carrying that same family spirit into the next generation. Heaven Sent is now a full-service shop with embroidery, screen printing, laser engraving, and promotional products all done in-house, proudly serving San Antonio and beyond.</p>
            <p className="about-press"><em>Featured in The San Antonio Business Journal, March 2011.</em></p>
            <div className="about-stats">
              <div className="stat">
                <strong>Since</strong>
                <span>2007</span>
              </div>
              <div className="stat">
                <strong>20,000+</strong>
                <span>Orders Shipped</span>
              </div>
              <div className="stat">
                <strong>Local</strong>
                <span>San Antonio, TX</span>
              </div>
            </div>
          </div>
          {/* Two-image "then and now" stack — sits AFTER the story text
              so customers read the founding story first, then see the
              "then and now" photos as visual context. */}
          <div className="about-image-stack">
            <figure className="about-image about-image--then">
              <img src="/images/susan-young.jpg" alt="Susan Subirias in the early days of Heaven Sent" loading="lazy" decoding="async" />
              <figcaption>Susan in the early days</figcaption>
            </figure>
            <figure className="about-image about-image--now">
              <img src="/images/home-content.webp" alt="The Heaven Sent team today" loading="lazy" decoding="async" />
              <figcaption>The Heaven Sent team today</figcaption>
            </figure>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="about-values">
        <p className="section-label">Why Choose Us</p>
        <h2 className="section-title">Our Commitment to You</h2>
        <div className="values-grid">
          <div className="value-card">
            <h3>Quality First</h3>
            <p>Every product goes through quality checks before delivery. We stand behind everything we sell.</p>
          </div>
          <div className="value-card">
            <h3>Fast Turnaround</h3>
            <p>Same-day services available on select items. We know deadlines matter.</p>
          </div>
          <div className="value-card">
            <h3>Competitive Pricing</h3>
            <p>Quality doesn't have to break the bank. We offer fair pricing on every order.</p>
          </div>
          <div className="value-card">
            <h3>Personal Service</h3>
            <p>You'll work directly with the team. No call centers, no runaround. Just real help.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <h2 className="script-font">Ready to Get Started?</h2>
        <p>Let's bring your brand to life together.</p>
        <div className="hero-buttons">
          <Link to="/quote" className="btn-pink">Get a Quote</Link>
          <Link to="/contact" className="btn-outline">Contact Us</Link>
        </div>
      </section>
    </main>
  );
}

export default About;
